export default __webpack_public_path__ + "static/media/13.5170ba27.JPG";